<template>
  <div id="meun" class="index" ref="Index">
    <header >
      <div class="header">
           <span>菜谱</span>
      </div>
    </header>
      <van-tabs class="ty-tabs" v-model="activeTitle">
      <van-tab title="推荐"  >
        <recomMenu></recomMenu>
      </van-tab>
      <van-tab title="我的" >
        <myMenu></myMenu>
      </van-tab>
    </van-tabs>
    <tabbar   :activeNew='active' />
    <!-- 导航 -->
     <router-view></router-view>
  </div>
</template>
<script>
import tabbar from "../common/tabbar";
import myMenu from "./myMenu";
import recomMenu from "./recomMenu";
export default {
  components: {
    tabbar,
    myMenu,
    recomMenu
  },
  created() {
    let {activeTitle} = this.$route.query;
    if(!activeTitle) return;
    this.activeTitle = +activeTitle;
  },
  data() {
    return {
      activeTitle: 0,
      active: 3,
      value: ""
    };
  },

  methods: {
    // 搜索
    search() {
      localStorage.setItem("searchValue", this.value);
      // localStorage.setItem("balck", "/index");
      this.$router.push("/search");
    },
    //搜索
    gosearch() {
      localStorage.removeItem("searchValue");
      this.$router.push("/search");
    }
  }
};
</script>

<style lang='scss' scoped>
.index {
  padding-top: 40px;
  transition: all 1s;
  // background: rgba(242, 242, 242, 1);
 background: rgba(242, 242, 242, 1);
  padding-bottom: 50px;
  height: 100%;
}
/deep/  .van-tabs__nav{
  background: rgba(242, 242, 242, 1);
}
.content {
  height: 20%;
  overflow: hidden;
}
.search-head {
  display: flex;
  margin: 20px 0px;
}
.ty-tabs{
  padding-top: 50px;
}
.ty-tabs /deep/ .van-tabs__wrap {
  position: fixed;
  top: 45px;
  width: 100%;
  z-index: 1111;
}
.header{
      font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 45px;
    color: rgba(102, 102, 102, 1);
    position: relative;
    padding-left: 20px;
    background-color: #ededed;
}
h3 {
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  margin-top: 25px;
}
.van-search {
  flex: 5;
  padding: 0;
  border-radius: 17px;
  margin: 0 10px;
  /* margin: 20px 60px; */
}
.van-icon {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-icon-plus:before {
  color: #fff;
}
/deep/ .van-tabs__line{
   background: linear-gradient( 90deg, rgba(116, 180, 43, 1) 0%, rgba(116, 180, 43, 0) 100% );
}
header {
  position: fixed;
  z-index: 999;
  top: 0;
  width: 100%;
}
</style>